export const trimPathDelimiters = (path: string): string => {
  return path.replace(/^[/\\]+|[/\\]+$/g, '');
};

export function trimPathEndDelimiter(path: string): string {
  return path.replace(/[/\\]+$/g, '');
}

/**
 * Strip the ";fileId" suffix that the search index retains on Google Drive
 * file paths so that identically-named files remain distinguishable in the
 * index while the UI shows human-readable names.
 */
export function stripDriveFileId(path: string): string {
  const idx = path.lastIndexOf(';');
  return idx >= 0 ? path.substring(0, idx) : path;
}

export const isSamePath = (pathA: string, pathB: string): boolean => {
  if (pathA === pathB) {
    return true;
  }
  if (!pathA || !pathB) {
    return false;
  }

  return trimPathDelimiters(pathA) === trimPathDelimiters(pathB);
};
